<template>
    <div class="param-of-search" ref="paramCover" @mouseleave="dragged = false" @mouseup="dragged = false" @mousemove="mouseMove">
        <div class="start-cover" :class="{hide: leftStopped}" >
            <img src="@/assets/icons/arrow_head_white_rigth.svg" alt="">
        </div>
        <div class="param-list" @scroll="scrolling" :style="{left: -scrollPosition + 'px'}" ref="paramList" @mousedown="startDragged">
            <search_param v-for="(param, id) of params" :name="param.name" :active="active === id" :key="id" @select="setActiveParam(id)"/>
        </div>
        <div class="end-cover" :class="{hide: rightStopped}">
            <img src="@/assets/icons/arrow_head_white_rigth.svg" alt="">
        </div>
    </div>
</template>

<script>
    import search_param from './search_param.vue'
    import {mapGetters} from "vuex";
    export default {
        name: "params_of_search",
        components:{
            search_param
        },
        props: {
            params: {
                type: Object,
                required: true
            },
            active: {
                type: String,
                required: true
            }
        },
        data:()=>({
            scrollPosition: 0,
            endPoint: 0,
            dragged: false,
            startScreenX: 0,
            startScrollPosition: 0,
            notFullList: true,
            nativeScrolled: -1, // -1, 0, 1
        }),
        updated(){
            this.calcEndPoint();
        },
        computed:{
            leftStopped(){
                if(this.pcVersion) return this.scrollPosition < 25;
                return this.nativeScrolled === -1;
            },
            rightStopped(){
                if(this.pcVersion) return this.scrollPosition > this.endPoint - 25;
                return this.nativeScrolled === 1;
            },
            ...mapGetters('window',['pcVersion'])
        },
        methods:{
            calcEndPoint(){
                const param = this.$refs.paramList.clientWidth;
                const cover = this.$refs.paramCover.clientWidth;
                this.notFullList = param < cover;
                this.endPoint = param - cover;
            },
            setActiveParam(param){
                if(!this.dragged)
                    this.$emit('change', param);
            },
            mouseMove({screenX}){
                if(this.dragged && this.pcVersion && !this.notFullList){
                    let direction = this.startScreenX - screenX;
                    if(this.trim(direction))
                        this.moveParamList(direction)
                }
            },
            trim(direction){
                if(this.scrollPosition <= 0 && direction < 0){
                    this.scrollPosition = 0;
                    return false
                }
                else if(this.scrollPosition >= this.endPoint && direction > 0){
                    this.scrollPosition = this.endPoint;
                    return false
                }
                else return true;
            },
            startDragged({screenX}){
                this.startScreenX = screenX;
                this.startScrollPosition = this.scrollPosition;
                this.dragged = true;
            },
            moveParamList(direction){
                if(this.trim(direction))
                    this.scrollPosition = direction + this.startScrollPosition;
            },
            scrolling({target}){
                let width = target.scrollWidth - target.offsetWidth;
                let position = width - target.scrollLeft ;

                if(position === width) this.nativeScrolled = -1;
                else if(position < 1) this.nativeScrolled = 1;
                else this.nativeScrolled = 0;
            }
        }
    }
</script>

<style scoped lang="scss">
    .param-of-search{
        height: 44px;
        position: relative;
        overflow: hidden;
        margin-top: -24px;
        margin-right: -32px;
        padding-top: 24px;
        padding-bottom: 32px;
        box-sizing: unset;

        .param-list{
            position: absolute;
            display: flex;
            flex-wrap: nowrap;
            margin-right: -32px;
            overflow: hidden;

            padding-right: 32px;
            @include mobile{
                padding-right: 24px;
            }
        }
        .start-cover, .end-cover{
            transition: $transition;
            display: flex;
            align-items: center;
            z-index: 10;
            pointer-events: none;
            position: absolute;
            top: 0;
            bottom: 0;
            width: 72px;
            background: red;

            &.hide{
                opacity: 0;
            }
            img{

                padding: 15px;
            }
            &.start-cover{
                background: linear-gradient(-90deg, rgba($bg_light, 0), $bg_light);
                left: 0;
                img{
                    transform: rotate(180deg);
                }
            }
            &.end-cover{
                right: 0;
                justify-content: flex-end;
                background: linear-gradient(90deg, rgba($bg_light, 0), $bg_light);
            }
        }
        @include tablet{
            $offset: 32px;
            .param-list{
                position: relative;
                overflow-x: scroll;
                padding-bottom: 12px;
                margin-right: $offset;
            }
            .end-cover{
                right: $offset !important;
            }
        }
    }
</style>
